import { useUIStore } from "../../store/uiStore";
import { pushUrl } from "../../store/uiStore";
import { headerPalette } from "../../lib/headerTheme";

export function ChoroplethToggle() {
  const { choroplethMode, setChoroplethMode } = useUIStore();
  const theme = useUIStore((s) => s.theme);
  const palette = headerPalette(theme);

  const onToggle = (mode: "raw" | "adjusted") => {
    setChoroplethMode(mode);
    pushUrl({ choroplethMode: mode });
  };

  const baseStyle: React.CSSProperties = {
    padding: "6px 12px",
    fontSize: 13,
    fontWeight: 500,
    border: `1px solid ${palette.buttonBorder}`,
    cursor: "pointer",
    background: palette.buttonBg,
    color: palette.logo,
  };
  const activeStyle: React.CSSProperties = {
    background: theme === "dark" ? "#3b82f6" : "#1f2937",
    color: "#fff",
    borderColor: theme === "dark" ? "#3b82f6" : "#1f2937",
  };

  return (
    <div
      role="group"
      aria-label="Choropleth mode toggle"
      style={{ display: "inline-flex", borderRadius: 4, overflow: "hidden" }}
    >
      <button
        type="button"
        onClick={() => onToggle("raw")}
        style={{
          ...baseStyle,
          ...(choroplethMode === "raw" ? activeStyle : {}),
          borderRadius: "4px 0 0 4px",
        }}
        aria-pressed={choroplethMode === "raw"}
        title="Raw model probability p̂"
      >
        Raw p̂
      </button>
      <button
        type="button"
        onClick={() => onToggle("adjusted")}
        style={{
          ...baseStyle,
          ...(choroplethMode === "adjusted" ? activeStyle : {}),
          borderRadius: "0 4px 4px 0",
          borderLeft: "none",
        }}
        aria-pressed={choroplethMode === "adjusted"}
        title="Equity-adjusted score p̃ = p̂ / max(r̂_s, r_min)"
      >
        Adjusted p̃
      </button>
    </div>
  );
}
